import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'

const { classof } = Object
const CLASS_OF_STRING = classof('')

function borrowMethod(Type, methodName) {
  return Function.prototype.call.bind(Type.prototype[methodName])
}

export const toUpperCase = borrowMethod(String, 'toUpperCase')
export const toLowerCase = borrowMethod(String, 'toLowerCase')

function transformFirstLetterCase(firstLetterTransformFn, str) {
  return firstLetterTransformFn(str.charAt(0)) + str.slice(1)
}

export function camelCaseToDashDelimited(myStr) {
  return toLowerCase(myStr.replace(/([a-z])([A-Z])/g, '$1-$2'))
}
export const toCamelCase = (str, delimiter = '_') =>
  toLowerCase(str).replace(new RegExp(`${delimiter}([a-z])`, 'g'), word => toUpperCase(word[1]))

export function randId() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

export const capitalizeFirstLetter = transformFirstLetterCase.part(toUpperCase)

export const unCapitalizeFirstLetter = transformFirstLetterCase.part(toLowerCase)

export const getLastWordFromCamelCase = str => str.split(/(?=[A-Z][^A-Z]+$)/).pop()

export const spacesToDots = str => str.toString().replace(' ', '.')

export function isString(obj) {
  return classof(obj) === CLASS_OF_STRING
}

const string = Object.assign(makeEmptyObj(), {
  toLowerCase,
  toUpperCase,
  toCamelCase,
  camelCaseToDashDelimited,
  randId,
  capitalizeFirstLetter,
  unCapitalizeFirstLetter,
  getLastWordFromCamelCase,
  spacesToDots,
  isString,
})

registerUtils({ string })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/string.js